import { render, staticRenderFns } from "./StaticRegistersForDropdown.vue?vue&type=template&id=1c4c6bd4&scoped=true"
import script from "./StaticRegistersForDropdown.vue?vue&type=script&lang=js"
export * from "./StaticRegistersForDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c6bd4",
  null
  
)

export default component.exports